import { Container } from 'typedi'
import { MeetingReportRoutes } from './services/report-routes'

Container.import([
  MeetingReportRoutes
])

export { default as MeetingReport } from './meetings.vue'
